// extracted by mini-css-extract-plugin
export default {"skeleton-accordion":"qVCwI","skeleton-accordion__title":"ZTTv6"};